export default __webpack_public_path__ + "static/media/slant-phone.a602a7fc.svg";